export default __webpack_public_path__ + "16f8cd0240ad79a70ae09469b7d5e1cf.png";